import './DimQuantitativeObjectivesTable.css';

import React, { useEffect, useState } from 'react';
import { createDimensionalObjectivesFromRegularObjectives } from '../../components/objectives/helper';
import ObjectiveTypeIcon from '../../components/objectives/ObjectiveTypeIcon';
import { toLocaleDateTime } from '../../../b2b-common/helpers';
import B2BTable from '../../../b2b-common/B2BTable';
import { Add } from '@mui/icons-material';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const DimQuantitativeObjectivesTable = ({ areaIndicator, onObjectiveClick, onNewObjective, showButtons = true }) => {

    const { t } = useB2BTranslation('b2b-plans');
    const [dimObjectives, setDimObjectives] = useState(null);

    useEffect(() => {
        if (areaIndicator) {
            const rawObjectives = areaIndicator.objectiveDTOs;
            const dimObjs = createDimensionalObjectivesFromRegularObjectives(rawObjectives);
            setDimObjectives(dimObjs);
        }
    }, [areaIndicator]);

    const headers = [
        { label: t('Type'), align: 'center' },
        { label: t('Start Date'), align: 'center' },
        { label: t('End Date'), align: 'center' },
        { label: t('Dimensions'), align: 'center' },
    ];

    const rows = dimObjectives ? dimObjectives.map((dimObj, index) =>
    ({
        id: index,
        cells: [
            { content: <ObjectiveTypeIcon objective={dimObj} showFieldName={false} />, align: 'center' },
            { content: toLocaleDateTime(dimObj.startDate), align: 'center' },
            { content: toLocaleDateTime(dimObj.endDate), align: 'center' },
            { content: dimObj.valuesPerDimension.length, align: 'center' },
        ],
    })) : [];

    const handleRowClick = (row) => {
        // the row.id is the index of the objective in the array
        if (onObjectiveClick) {
            // console.log('dimObjectives[row.id]:', dimObjectives[row.id]);
            onObjectiveClick(dimObjectives[row.id]);
        };
    };

    return (
        <B2BTable
            headers={headers}
            rows={rows}
            className={'dim-quantitative-objectives'}
            onRowClick={handleRowClick}
            buttons={showButtons ?
                [
                    {
                        label: t('New Dimensional Objective'),
                        icon: <Add />,
                        onClick: onNewObjective,
                    },
                ] : null
            }
        />
    );
};

export default DimQuantitativeObjectivesTable;